import React, { useCallback } from 'react'
import { useMemo } from 'react'
import { useRef } from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
// import Streamer from '../../aws-transcribe/streamer'
import Streamer from '../../transcribe/main'

const Captions = ({ stream }) => {
  const streamRef = useRef()
  streamRef.current = stream
  const streamId = useMemo(() => {
    return stream && stream.id
  }, [stream])
  const streamLive = stream && stream.live_now
  const [captionWS, setCaptionWS] = useState(null)
  // use ref so that callback can see the websocket
  const captionWSRef = useRef()
  captionWSRef.current = captionWS

  const handleData = data => {
    if (
      captionWSRef.current &&
      captionWSRef.current.readyState === captionWSRef.current.OPEN
    ) {
      captionWSRef.current.send(JSON.stringify(data))
    }
  }

  const [streamer, setStreamer] = useState(
    new Streamer(data => {
      handleData(data)
    })
  )

  const stopCaptions = () => {
    streamer.stopStreaming()
  }

  const startCaptions = () => {
    // streamer.init()
    streamer.startStreaming()
  }

  // send stream id
  const sendStreamId = () => {
    if (
      streamRef.current &&
      streamRef.current.id &&
      captionWSRef.current &&
      captionWSRef.current.readyState === captionWSRef.current.OPEN
    ) {
      captionWSRef.current.send(
        JSON.stringify({ stream_id: streamRef.current.id, streamer: true })
      )
    }
  }

  const connectToCaptionWS = (tries = 0) => {
    const newWS = new WebSocket(process.env.REACT_APP_CAPTIONS_ORIGIN_URL)
    // try to send streamId incase of reconnect
    newWS.onopen = () => sendStreamId()
    // handle possible messages
    newWS.onmessage = event => {
      if (event.data === 'ping') {
        return newWS.send('pong')
      } else if (event.data === 'start') {
        return startCaptions()
      } else if (event.data === 'stop') {
        return stopCaptions()
      }
    }
    // try to reconnect on close
    newWS.onclose = () => {
      setTimeout(() => {
        connectToCaptionWS(tries + 1)
      }, tries * 500)
    }
    setCaptionWS(newWS)
  }

  // connect to websocket when page loads
  useEffect(() => {
    connectToCaptionWS()
  }, [])

  // send streamId when the streamId is recieved
  useEffect(() => {
    sendStreamId()
  }, [streamId])

  return null
}

export default Captions



// WEBPACK FOOTER //
// ./src/pages/Stream/captions.jsx